const giphy = require('giphy-api')({
  apiKey: 'F0xXH4MlIP1fjMo4bWHtk2CmJFqpYi7G',
  https: true
});
const debounce = require('debounce');
import {closeAllDropdowns} from '../../utils/utils';

export default {
  beforeDestroy() {
    this.observer.disconnect();
  },
  mounted() {
    this.observer = new MutationObserver(() => {
      //this.$refs.dropdownContent.classList.contains('show')
      this.modalState = null;
    });

    this.observer.observe(this.$refs.dropdownContent, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    });

    this.gifDebounce = debounce(this.updateGifs, 500);
  },
  methods: {
    closeAllDropdowns(){
      closeAllDropdowns()
    },
    clearParams(link) {
      return link.split('?')[0];
    },
    setModalState(state) {
      this.modalState = state;

      switch (this.modalState) {
        case 'gif':
          if (this.gifSearch === '' && this.gifImages.length === 0) {
            this.updateGifs();
            break;
          }
      }
    },
    updateGifs() {
      const limit = 50;
      if (this.gifSearch === '') {
        giphy.trending(
          {limit: limit},
          (err, res) => this.gifImages = res.data,
        );
      } else {
        giphy.search(
          {
            q: this.gifSearch,
            limit: limit,
          },
          (err, res) => this.gifImages = res.data,
        );
      }
    },
  },
  watch: {
    'gifSearch'() {
      this.gifDebounce();
    },
  },
  data() {
    return {
      eventPage: '',

      modalState: null,

      gifImages: [],
      gifSearch: '',
      gifDebounce: null,
    };
  },
};
